import { render, staticRenderFns } from "./AnchorPositionPicker.vue?vue&type=template&id=649e897c&scoped=true&"
import script from "./AnchorPositionPicker.vue?vue&type=script&lang=js&"
export * from "./AnchorPositionPicker.vue?vue&type=script&lang=js&"
import style0 from "./AnchorPositionPicker.vue?vue&type=style&index=0&id=649e897c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e897c",
  null
  
)

export default component.exports